import type { SportKey } from '../../sports.types';

export const SPORT_ICON_TEST_IDS = {
  image: 'sport-icon-image',
  fallback: 'sport-icon-fallback',
} as const;

/**
 * Text stand-in shown only when the CDN icon fails to load — see the note in SportIcon.tsx.
 * Emoji rather than an initial: a bare "B" beside a basketball game reads as nothing.
 */
export const SPORT_ICON_FALLBACK_GLYPH: Record<SportKey, string> = {
  FOOTBALL: '⚽',
  BASKETBALL: '🏀',
  FORMULA_ONE: '🏎️',
};
